/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import React, { useState } from 'react';
import { object, func } from 'prop-types';
import { useLocation } from 'react-router';
import ReactHTMLParser from 'react-html-parser';

import CloseIcon from '@material-ui/icons/Close';
import { Query } from '@apollo/client/react/components';
import { Dialog, DialogTitle, DialogContent, withStyles, IconButton, Grid } from '@material-ui/core';

import { GRAPHQL_ENV } from '../../../../../../gql';
import findContent from '../../../../../../gql/queries/findContent';

const styles = () => ({
    dialog: {
        fontSize: '14px',
        '& .center': {
            display: 'flex',
            justifyContent: 'center',
        },
        '& .right': {
            display: 'flex',
            justifyContent: 'right',
        },
        '& .title': {
            boxShadow: '0px 4px 4px 0px #00000040',
            margin: 0,
            padding: 0,
            '& .mbp-account-MuiGrid-container': {
                alignItems: 'center',
            },
            '& .headerTitle': {
                fontWeight: '700',
            },
        },
        '& .content': {
            lineHeight: 2,
            padding: '30px',
            textAlign: 'center',
        },
    },
});

const GuestPromoCode = ({ classes }) => {
    const { hash } = useLocation();
    const [displayPromoCode, setDisplayPromoCode] = useState(hash === '#guest-started');
    
    const promoCodePayload = { 
        brand: 'global',
        environment: GRAPHQL_ENV,
        contentType: 'recipient_book_promo_code_modal'
    };
    const PROMO_CODE_QUERY = findContent(promoCodePayload);

    return (
        <Query query={PROMO_CODE_QUERY}>
            {({ data, loading, error }) => {
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: PROMO_CODE_QUERY,
                        component: 'GuestPromoCode.js',
                        message: 'Error loading guest promo code',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                };

                const promoCodeContent = data?.findContent?.content?.entries?.[0];
                if (loading || !promoCodeContent)
                    return null;

                return (
                    <Dialog open={displayPromoCode} onClose={() => setDisplayPromoCode(false)} className={classes.dialog}>
                        <DialogTitle className='title' style={{ backgroundColor: promoCodeContent.dialog_title.bg_color}}>
                            <Grid container>
                                <Grid item lg={4} md={4} sm={4} xs={3} />
                                <Grid item lg={4} md={4} sm={4} xs={6} className='center headerTitle'>{ReactHTMLParser(promoCodeContent.dialog_title.top_modal_title)}</Grid>
                                <Grid item lg={4} md={4} sm={4} xs={3} className='right'>
                                    <IconButton aria-label="close" onClick={() => setDisplayPromoCode(false)} sx={(theme)=> ({
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: theme.palette.grey[500],
                                        })}
                                        >
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </DialogTitle>
                        <DialogContent className='content'>
                            <Grid container spacing={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>{ReactHTMLParser(promoCodeContent.modal.title)}</Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>{ReactHTMLParser(promoCodeContent.modal.description)}</Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>{ReactHTMLParser(promoCodeContent.modal.coupon_copy)}</Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>{ReactHTMLParser(promoCodeContent.modal.coupon_code)}</Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>{ReactHTMLParser(promoCodeContent.modal.coupon_helper_copy)}</Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                );
            }}
        </Query>
    )
};

GuestPromoCode.propTypes = {
    classes: object.isRequired,
    promoCodeContent: object.isRequired,
    setDisplayPromoCode: func.isRequired,
};

export default withStyles(styles)(GuestPromoCode);
